export const colors = {
  bleuSavoir: '#17386E',
  vertProgres: '#4CE0C2',
  orangeElan: '#FFA726',
  bleuCiel: '#EAF4FB',
  grisClair: '#F5F5F5',
  grisTexte: '#4A4A4A',
};
